import { render, staticRenderFns } from "./MyselfSoftware.vue?vue&type=template&id=aedfd1a0&scoped=true&"
import script from "./MyselfSoftware.vue?vue&type=script&lang=js&"
export * from "./MyselfSoftware.vue?vue&type=script&lang=js&"
import style0 from "./MyselfSoftware.vue?vue&type=style&index=0&id=aedfd1a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aedfd1a0",
  null
  
)

export default component.exports